export default __webpack_public_path__ + "static/media/whitedamage.0205237c.png";